import { createAppThunk } from "integrations/redux/hooks"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { updateWorkspaceMember } from "features/entity-caching/members/UserManagementSlice"
import { selectUserID } from "user/profile/selectors"

export const recordRecentSearch = createAppThunk(
    ({ pluginName, data }: { pluginName: string; data: unknown }, { getState, dispatch }) => {
        const state = getState()
        const activeWorkspaceId = selectActiveWorkspaceId()(state)
        const userId = selectUserID(state)
        if (!activeWorkspaceId || !userId) return
        dispatch(
            updateWorkspaceMember({
                workspaceId: activeWorkspaceId,
                userId,
                attributes: { recentSearch: { pluginName, data } },
            })
        )
    }
)
